import type { MonitoringWorkflow } from '../../services/ruutsApi/getMonitoringWorkflows'

export type MonitoringWorkflowOption = {
  id: number
  label: string
  value: number
  siteRequired: boolean
}

type ProgramWorkflowConfig = { monitoringWorkflowIds?: number[] } | null | undefined

export const getProgramWorkflows = (
  monitoringWorkflows: MonitoringWorkflow[] | undefined,
  programConfig: ProgramWorkflowConfig,
): MonitoringWorkflow[] => {
  const enabledIds = programConfig?.monitoringWorkflowIds ?? []
  return (monitoringWorkflows ?? []).filter(workflow => enabledIds.includes(workflow.id))
}

export const getProgramWorkflowOptions = (
  monitoringWorkflows: MonitoringWorkflow[] | undefined,
  programConfig: ProgramWorkflowConfig,
): MonitoringWorkflowOption[] =>
  getProgramWorkflows(monitoringWorkflows, programConfig).map(workflow => ({
    id: workflow.id,
    label: `${workflow.description} (${workflow.name})`,
    value: workflow.id,
    siteRequired: workflow.siteRequired,
  }))
